module.exports = __webpack_public_path__ + "static/media/facebook.3026d85a.png";